export default __webpack_public_path__ + "static/media/as.3eef14f8.svg";